// extracted by mini-css-extract-plugin
export var box = "profile-module--box--13685";
export var cert = "profile-module--cert--c84b5";
export var certList = "profile-module--certList--21521";
export var description = "profile-module--description--ccfeb";
export var expertise = "profile-module--expertise--e9c24";
export var expertiseList = "profile-module--expertiseList--105b4";
export var flexbox = "profile-module--flexbox--1620b";
export var gatsbyRespImageBackgroundImage = "profile-module--gatsby-resp-image-background-image--f875a";
export var gatsbyRespImageLink = "profile-module--gatsby-resp-image-link--2da37";
export var image = "profile-module--image--580dc";
export var input = "profile-module--input--cb8b7";
export var load8 = "profile-module--load8--a61db";
export var loader = "profile-module--loader--42c9c";
export var profile = "profile-module--profile--1a6a8";
export var profileHeader = "profile-module--profileHeader--29e8f";
export var profileHeaderContent = "profile-module--profileHeaderContent--efa6d";
export var socialImage = "profile-module--socialImage--7d9bc";
export var socials = "profile-module--socials--08e61";
export var socialsList = "profile-module--socialsList--58040";
export var title = "profile-module--title--096ad";